(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("resolve", [], factory);
	else if(typeof exports === 'object')
		exports["resolve"] = factory();
	else
		root["resolve"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setResolveStatus = exports.setInitialResolveStatus = exports.removeAllResolveData = exports.removeResolveData = exports.setResolveData = exports.ACTIONS = undefined;

var _keymirror = __webpack_require__(6);

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACTIONS = exports.ACTIONS = (0, _keymirror2.default)({
    SET_RESOLVE_DATA: null,
    REMOVE_RESOLVE_DATA: null,
    REMOVE_ALL_RESOLVE_DATA: null,
    SET_INITIAL_RESOLVE_STATUS: null,
    SET_RESOLVE_STATUS: null
});

var setResolveData = exports.setResolveData = function setResolveData(resolve) {
    return { type: ACTIONS.SET_RESOLVE_DATA, resolve: resolve };
};
var removeResolveData = exports.removeResolveData = function removeResolveData(id) {
    return { type: ACTIONS.REMOVE_RESOLVE_DATA, id: id };
};
var removeAllResolveData = exports.removeAllResolveData = function removeAllResolveData() {
    return { type: ACTIONS.REMOVE_ALL_RESOLVE_DATA };
};
var setInitialResolveStatus = exports.setInitialResolveStatus = function setInitialResolveStatus(status) {
    return { type: ACTIONS.SET_INITIAL_RESOLVE_STATUS, status: status };
};
var setResolveStatus = exports.setResolveStatus = function setResolveStatus(status) {
    return { type: ACTIONS.SET_RESOLVE_STATUS, status: status };
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _resolve = __webpack_require__(5);

Object.defineProperty(exports, 'Resolve', {
  enumerable: true,
  get: function get() {
    return _resolve.Resolve;
  }
});
Object.defineProperty(exports, 'commonPath', {
  enumerable: true,
  get: function get() {
    return _resolve.commonPath;
  }
});
Object.defineProperty(exports, 'findUnResolvedRoutes', {
  enumerable: true,
  get: function get() {
    return _resolve.findUnResolvedRoutes;
  }
});
Object.defineProperty(exports, 'findRoute', {
  enumerable: true,
  get: function get() {
    return _resolve.findRoute;
  }
});
Object.defineProperty(exports, 'createTreeStructure', {
  enumerable: true,
  get: function get() {
    return _resolve.createTreeStructure;
  }
});

var _actions = __webpack_require__(0);

Object.defineProperty(exports, 'setResolveData', {
  enumerable: true,
  get: function get() {
    return _actions.setResolveData;
  }
});
Object.defineProperty(exports, 'removeResolveData', {
  enumerable: true,
  get: function get() {
    return _actions.removeResolveData;
  }
});
Object.defineProperty(exports, 'setInitialResolveStatus', {
  enumerable: true,
  get: function get() {
    return _actions.setInitialResolveStatus;
  }
});
Object.defineProperty(exports, 'setResolveStatus', {
  enumerable: true,
  get: function get() {
    return _actions.setResolveStatus;
  }
});

var _reducer = __webpack_require__(7);

Object.defineProperty(exports, 'resolveReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.resolveReducer;
  }
});

var _resolveMiddleware = __webpack_require__(8);

Object.defineProperty(exports, 'resolveMiddleware', {
  enumerable: true,
  get: function get() {
    return _resolveMiddleware.resolveMiddleware;
  }
});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createTreeStructure = exports.commonPath = exports.findRoute = exports.findUnResolvedRoutes = exports.Resolve = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _actions = __webpack_require__(0);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Resolve = exports.Resolve = function () {
    function Resolve() {
        _classCallCheck(this, Resolve);

        this.init = this.init.bind(this);
        this.setLastResolvedPath = this.setLastResolvedPath.bind(this);
        this.resolve = this.resolve.bind(this);
        this.cleanResolvedData = this.cleanResolvedData.bind(this);
        this.resolvedData = [];
        this.caseSensitive = true;
    }

    _createClass(Resolve, [{
        key: 'setLastResolvedPath',
        value: function setLastResolvedPath(path) {
            this.lastResolvedPath = path;
        }
    }, {
        key: 'init',
        value: function init(options) {

            this.baseName = options.baseName;

            if (!(this.baseName instanceof RegExp) && typeof this.baseName === 'string') this.baseName = trimSlashes(this.baseName);

            if (!this.baseName) this.baseName = '';

            this.routes = options.routes;
            this.store = options.store;
            this.beforeResolveCallback = options.beforeResolveCallback;
            this.afterResolveCallback = options.afterResolveCallback;
            this.lastResolvedPath = null;
            this.animationTime = options.animationTime;
            this.lastUrl;

            if (options.hasOwnProperty('caseSensitive')) {
                this.caseSensitive = options.caseSensitive;
            }
        }
    }, {
        key: 'cleanResolvedData',
        value: function cleanResolvedData(url) {
            if (url === null) {
                if (this.store) this.store.dispatch((0, _actions.removeAllResolveData)());

                this.resolvedData = [];

                return;
            }

            for (var i = this.resolvedData.length - 1; i >= 0; i--) {
                if (!isPartOf(this.resolvedData[i].url.split('/'), url.split('/'))) {
                    if (this.store) this.store.dispatch((0, _actions.removeResolveData)(this.resolvedData[i].id));

                    this.resolvedData.splice(i, 1);
                }
            }
        }
    }, {
        key: 'resolve',
        value: function resolve(_ref) {
            var _this = this;

            var url = _ref.url;


            if (!url) return Promise.resolve();

            if (!this.caseSensitive) url = url.toLowerCase();

            url = trimSlashes(url);

            if (this.baseName instanceof RegExp) {
                var base = url.match(this.baseName);
                if (base && (url.charAt(base[0].length) === '/' || base[0].length === url.length)) {
                    url = url.slice(base[0].length + (url.charAt(base[0].length) === '/' ? 1 : 0));
                }
            } else {
                if (url.startsWith(this.baseName)) {
                    url = url.slice(this.baseName.length + (url.charAt(this.baseName.length) === '/' ? 1 : 0));
                }
            }

            if (url === this.lastUrl) return Promise.resolve();

            var animationPromise = new Promise(function (resolve) {
                setTimeout(function () {
                    resolve();
                }, _this.animationTime || 0);
            });

            if (this.store && typeof this.store.dispatch === 'function') this.store.dispatch((0, _actions.setResolveStatus)(true));

            var urlDiff = findUrlDiff(url, this.lastUrl);

            this.lastUrl = url;

            if (typeof this.beforeResolveCallback === 'function') this.beforeResolveCallback();

            this.cleanResolvedData(url);

            var unResolvedRoutes = findUnResolvedRoutes(commonPath(this.lastResolvedPath, urlDiff), this.routes, '', this.setLastResolvedPath);

            if (!unResolvedRoutes) return Promise.resolve().then(function () {
                if (_this.store && typeof _this.store.getState === 'function' && !_this.store.getState().resolve.initial_status) _this.store.dispatch((0, _actions.setInitialResolveStatus)(true));

                if (typeof _this.afterResolveCallback === 'function') _this.afterResolveCallback();
            });

            var resolves = findRoute(url, unResolvedRoutes, this.lastResolvedPath, this.setLastResolvedPath);

            var async = resolves.filter(function (r) {
                return r.async;
            });
            var sync = resolves.filter(function (r) {
                return !r.async;
            });
            var r = [];

            var status = 200;

            /*
             * Call all async promises and add them to array. We can call them immediately as
             * they are async. All sync resolves are chained to all of these.
             */
            async.forEach(function (o) {
                o.resolves.forEach(function (resolve) {
                    r.push(resolve.data(o.variables).then(function (response) {
                        if (_this.store) _this.store.dispatch((0, _actions.setResolveData)(_defineProperty({}, resolve.id, response)));

                        _this.resolvedData.push({
                            id: resolve.id,
                            url: o.url
                        });
                    }, function (error) {
                        if (error.message == 404) status = 404;
                    }));
                });
            });

            var promiseAll = Promise.all(r);

            /*
             * Chain all sync resolves so that every resolve that is on lower level will resolve before
             * next one is called.
             */
            sync.forEach(function (o) {
                o.resolves.forEach(function (resolve) {
                    promiseAll = promiseAll.then(function () {
                        return resolve.data(o.variables).then(function (response) {
                            if (_this.store) _this.store.dispatch((0, _actions.setResolveData)(_defineProperty({}, resolve.id, response)));

                            _this.resolvedData.push({
                                id: resolve.id,
                                url: o.url
                            });

                            return Promise.resolve();
                        }, function (error) {
                            if (error.message == 404) status = 404;
                        });
                    });
                });
            });

            var afterResolve = function afterResolve() {
                if (_this.store && typeof _this.store.getState === 'function' && !_this.store.getState().resolve.initial_status) _this.store.dispatch((0, _actions.setInitialResolveStatus)(true));

                if (_this.store && typeof _this.store.dispatch === 'function') _this.store.dispatch((0, _actions.setResolveStatus)(false));

                if (typeof _this.afterResolveCallback === 'function') _this.afterResolveCallback();

                return Promise.resolve(status);
            };

            return promiseAll.then(function () {
                return animationPromise;
            }).then(afterResolve, afterResolve);
        }
    }]);

    return Resolve;
}();

/**
 * The trimSlashes() method removes slashes from both ends of a string.
 * @param v String to be trimmed
 */


var trimSlashes = function trimSlashes(v) {
    return v.slice(v.startsWith('/') ? 1 : 0, v.length - (v.endsWith('/') ? 1 : 0));
};

var findUnResolvedRoutes = exports.findUnResolvedRoutes = function findUnResolvedRoutes(resolved_route, routes) {
    var routes_url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var setResolvedPath = arguments[3];

    if (resolved_route === null) return routes;

    for (var i = 0; i < routes.length; i++) {
        var subject = trimSlashes(routes_url + '/' + routes[i].path);
        if (isPartOf(subject.split('/'), resolved_route.split('/'))) {

            setResolvedPath(subject);

            if (routes[i].children) {
                var route = findUnResolvedRoutes(resolved_route, routes[i].children, subject, setResolvedPath);

                return route || routes[i].children;
            }

            // Route is fully resolved.
            return [];
        }
    }

    return null;
};

/**
 * Find to route from routes that is specified by url.
 *
 * @param url Current url
 * @param routes Route table
 * @param resolved_route Prefix url. Used for recursion
 * @returns {Array} List of all resolves
 */
var findRoute = exports.findRoute = function findRoute(url, routes) {
    var resolved_route = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var setResolvedPath = arguments[3];

    var resolves = [];

    if (resolved_route === null) resolved_route = '';

    for (var i = 0; i < routes.length; i++) {
        var subject = trimSlashes(resolved_route + '/' + routes[i].path);

        if (isPartOf(subject.split('/'), url.split('/'))) {

            if (routes[i].resolve) {
                var resolve_data = {
                    variables: getVariables(subject.split('/'), url.split('/')),
                    resolves: routes[i].resolve,
                    url: subject,
                    async: !(typeof routes[i].async === 'boolean' && !routes[i].async)
                };

                resolves.push(resolve_data);
            }

            setResolvedPath(subject);

            if (routes[i].children) Array.prototype.push.apply(resolves, findRoute(url, routes[i].children, subject, setResolvedPath));

            return resolves;
        }
    }

    return [];
};

/**
 * Check if path1 is part of path2. Path1 should be subset of Path2
 *
 * @param path1 String array that consist path1. shouldn't contain slashes
 * @param path2 String array that consist path2. shouldn't contain slashes
 * @returns {boolean} True if path1 is subset of path2 starting from beginning. False otherwise
 */
var isPartOf = function isPartOf(path1, path2) {

    if (path1.length === 1 && path1[0] === '') return true;

    if (path1 === null || path2 === null || path1.length > path2.length) return false;

    for (var i = 0; i < path1.length; i++) {
        if (path1[i] !== path2[i] && path1[i].charAt(0) !== ':') return false;
    }

    return true;
};

/**
 * Get url variables. All variables should start with :
 *
 * @param path1 Path that has strings starting with : that are used to catch variables
 * @param path2 Url that has variables.
 * @returns {Array} Found variables in objects with id as name and value as string value found.
 */
var getVariables = function getVariables(path1, path2) {
    var variables = {};
    for (var i = 0; i < path1.length; i++) {
        if (path1[i].charAt(0) === ':') {
            variables[path1[i].slice(1)] = path2[i];
        }
    }

    return variables;
};

var commonPath = exports.commonPath = function commonPath(path1, path2) {
    var common = [];

    if (path1 === '' || path2 === '' && path1 !== null) return '';

    if (typeof path1 !== 'string' || typeof path2 !== 'string') return null;

    path1 = trimSlashes(path1).split('/');
    path2 = trimSlashes(path2).split('/');

    for (var i = 0; i < path1.length && i < path2.length; i++) {

        if (path1[i] !== path2[i] && (path1[i].charAt(0) !== ':' ^ path2[i].charAt(0) !== ':') === 0) break;

        common.push(path2[i].charAt(0) === ':' ? path2[i] : path1[i]);
    }

    return trimSlashes(common.join('/'));
};

var createTreeStructure = exports.createTreeStructure = function createTreeStructure(node, async) {
    return node.map(function (r) {
        var clone = Object.assign({}, r);
        if (!(typeof clone.async === 'boolean' ? clone.async === async : async) && clone.resolve) delete clone.resolve;

        if (clone.children) clone.children = createTreeStructure(clone.children, async);

        return clone;
    });
};

var findUrlDiff = function findUrlDiff(url1, url2) {
    var common = [];

    if (typeof url1 !== 'string' || typeof url2 !== 'string') return null;

    url1 = trimSlashes(url1).split('/');
    url2 = trimSlashes(url2).split('/');

    for (var i = 0; i < url1.length && i < url2.length; i++) {

        if (url1[i] !== url2[i]) break;

        common.push(url1[i]);
    }

    return trimSlashes(common.join('/'));
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2014 Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */



/**
 * Constructs an enumeration with keys equal to their value.
 *
 * For example:
 *
 *   var COLORS = keyMirror({blue: null, red: null});
 *   var myColor = COLORS.blue;
 *   var isColorValid = !!COLORS[myColor];
 *
 * The last line could not be performed if the values of the generated enum were
 * not equal to their keys.
 *
 *   Input:  {key1: val1, key2: val2}
 *   Output: {key1: key1, key2: key2}
 *
 * @param {object} obj
 * @return {object}
 */
var keyMirror = function(obj) {
  var ret = {};
  var key;
  if (!(obj instanceof Object && !Array.isArray(obj))) {
    throw new Error('keyMirror(...): Argument must be an object.');
  }
  for (key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    ret[key] = key;
  }
  return ret;
};

module.exports = keyMirror;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resolveReducer = undefined;

var _actions = __webpack_require__(0);

var initialState = {
    data: [],
    initial_status: false,
    resolve_path: null
};

var resolveReducer = exports.resolveReducer = function resolveReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var temp_state = Object.assign({}, state);

    switch (action.type) {
        case _actions.ACTIONS.SET_RESOLVE_DATA:
            for (var key in action.resolve) {
                temp_state.data[key] = action.resolve[key];
            }return temp_state;
        case _actions.ACTIONS.REMOVE_RESOLVE_DATA:
            if (temp_state.data[action.id]) delete temp_state.data[action.id];
            return temp_state;
        case _actions.ACTIONS.REMOVE_ALL_RESOLVE_DATA:
            temp_state.data = [];
            return temp_state;
        case _actions.ACTIONS.SET_INITIAL_RESOLVE_STATUS:
            return Object.assign({}, state, { initial_status: action.status });
        case _actions.ACTIONS.SET_RESOLVE_STATUS:
            return Object.assign({}, state, { resolve_progress: action.status });
        default:
            return state;
    }
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resolveMiddleware = undefined;

var _reactRouterRedux = __webpack_require__(9);

var resolveMiddleware = exports.resolveMiddleware = function resolveMiddleware(resolve) {
    return function () {
        return function (next) {
            return function (action) {
                if (![_reactRouterRedux.CALL_HISTORY_METHOD, _reactRouterRedux.LOCATION_CHANGE].find(function (t) {
                    return t === action.type;
                })) {
                    return next(action);
                }

                var _action$payload = action.payload,
                    args = _action$payload.args,
                    pathname = _action$payload.pathname;


                resolve.resolve({ url: args ? args[0] : pathname }).then(function (status) {
                    switch (status) {
                        case 404:
                            if (action.type === _reactRouterRedux.CALL_HISTORY_METHOD) {
                                if (window.location.href.endsWith(action.payload.args[0])) {
                                    action.payload.method = "replace";
                                }
                                action.payload.args = ["/404"];
                            }
                            break;
                    }

                    next(action);
                });
            };
        };
    };
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(1);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(2);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(10);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(11);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(1);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(2);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ })
/******/ ]);
});
//# sourceMappingURL=resolve.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kairo/react-redux-resolve/lib/resolve.js
// module id = 572
// module chunks = 0